/**
 * Take the focus off a button that was clicked with the mouse (or touched). A barcode scan ends with Enter, and Enter
 * (or Space) on a focused button clicks it again: a scan must not switch the theme or the station. A button pressed with
 * the keyboard keeps the focus, so keyboard users do not lose their place (`detail` counts the clicks, 0 for a key).
 */
export const blurAfterPointer = (event: React.MouseEvent<HTMLElement>): void => {
    if (0 < event.detail) {
        event.currentTarget.blur();
    }
};
